import { Box } from "@mui/material";
import React from "react";
import NumberedTitle from "../../Components/Title";
import ScopeTable from "./ScopeTable";
import Notes from "./Notes";

export default function ScopeTab() {
  return (
    <Box sx={{ width: 1000 }}>
      <ScopeTable />

      <NumberedTitle number="2" title="Notes" />
      <Notes />
    </Box>
  );
}
